/**
 * Application-wide constants
 * This file contains commonly used constants across the entire application
 */

// Canvas and Image Dimensions
export const CANVAS_DIMENSIONS = {
  WIDTH: 736,
  HEIGHT: 416,
} as const

// Car Parking scaling factors (used in regions artboard)
export const CAR_PARKING_SCALE = {
  SCALE_X: 736 / 1280,
  SCALE_Y: 416 / 720,
  INVERSE_SCALE_X: 1280 / 736,
  INVERSE_SCALE_Y: 720 / 416,
} as const

// Default image sizes for various contexts
export const DEFAULT_IMAGE_SIZES = {
  CANVAS: { width: CANVAS_DIMENSIONS.WIDTH, height: CANVAS_DIMENSIONS.HEIGHT } as { width: number; height: number },
} as const
